import { userLikeSceneActions } from '../../actions/user/userLikeSceneActions.js';

const INITIAL_STATE = {
    isFetching: false,
    error: '',
    scenes:[],
    count: 0,
      sites: {
        "available": [
        {
        "siteId": 25,
        "shortName": "ap",
        "name": "Ass Parade"
        }],
        "selected":  {
          "siteId": 25,
          "shortName": "ap",
          "name": "Ass Parade"
          }
      },
      models: {
        available: [],
        selected: []
      },
      tags: {
        available: [],
        selected: []
      }
}

const userLikeSceneReducers = (state = INITIAL_STATE, action) =>{
    switch(action.type){
        case userLikeSceneActions.SCENE_LIKE_REQ:
            return {
                ...state,
                isFetching: true
            };
        case userLikeSceneActions.SCENE_LIKE_SUC:
            return{
                ...state,
                isFetching: false,
                scenes: action.scenes,
                // sites: action.sites,
                // models: action.models,
                // tags: action.tags,
                count: action.count
            }
        case userLikeSceneActions.SCENE_LIKE_ERR:
            return{
                ...state,
                isFetching: false,
                error: action.error
            }
        default:
            return state;
    }
};

export default userLikeSceneReducers;
